import { useLayoutEffect } from 'react'
import { Link } from 'react-router-dom'
import { ContentColumn } from '../components/layout/ContentColumn/ContentColumn'

export default function CookiesPage() {
  useLayoutEffect(() => {
    const measure = () => {
      const headerEl = document.querySelector('header') as HTMLElement | null
      const stickyNavEl = document.querySelector('.sticky.top-0') as HTMLElement | null
      const headerH = headerEl?.offsetHeight ?? 0
      const navH = stickyNavEl?.offsetHeight ?? 0
      document.documentElement.style.setProperty('--header-nav-height', `${headerH + navH}px`)
    }
    measure()
    requestAnimationFrame(measure)
    window.addEventListener('resize', measure)
    return () => window.removeEventListener('resize', measure)
  }, [])

  return (
    <>
      <div className="bg-gray-50 min-h-screen text-[#232323]">
        <section className="relative overflow-hidden bg-brand-navy py-20 md:py-28">
          <ContentColumn anchor="cookies-hero" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <h1 className="font-sans text-[42px] sm:text-[48px] md:text-[56px] font-bold text-gray-50 mb-6 leading-[1.3] tracking-[-0.02em]">
                Cookie Policy
              </h1>
              <p className="text-[21px] leading-[1.58] text-gray-50/85 font-body mb-10">
                How and why gazar.dev uses cookies.
              </p>
            </div>
          </ContentColumn>
        </section>

        <section className="border-b border-border-subtle bg-white">
          <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-4">
            <nav aria-label="Breadcrumb">
              <ol className="flex items-center gap-2 text-label font-body text-gray-900/60">
                <li>
                  <Link to="/" className="transition-colors hover:text-gray-900 focus:text-gray-900 focus:outline-none">Home</Link>
                </li>
                <li className="font-heading text-gray-900">/</li>
                <li className="font-heading text-gray-900" aria-current="page">Cookie Policy</li>
              </ol>
            </nav>
          </div>
        </section>

        <section className="bg-white py-20">
          <ContentColumn anchor="cookies-main" className="max-w-4xl mx-auto px-4">
            <div className="prose prose-lg max-w-none">
              <div className="bg-white border-2 border-gray-200 rounded-smooth-lg p-8 sm:p-12 shadow-sm">
                <h2 className="font-heading text-3xl font-bold uppercase text-gray-900 mb-6">Cookie Policy</h2>

                <div className="space-y-6 font-body text-base text-[#232323] leading-relaxed">
                  <div>
                    <p className="mb-4"><strong>Last Updated:</strong> July 2026</p>
                    <p className="mb-4">
                      This Cookie Policy explains how gazar.dev, operated by QUEEK LIMITED, uses cookies and similar technologies. It should be read alongside our{' '}
                      <Link to="/privacy" className="text-[#2d5016] hover:text-[#1a5a3a] hover:underline font-semibold">Privacy Policy</Link>.
                    </p>
                  </div>

                  <div>
                    <h3 className="font-heading text-xl font-bold uppercase text-gray-900 mb-3 mt-8">What Are Cookies</h3>
                    <p className="mb-4">
                      Cookies are small text files stored on your device by your browser. Similar technologies such as local storage work in the same way. They let a site remember information between page loads.
                    </p>
                  </div>

                  <div>
                    <h3 className="font-heading text-xl font-bold uppercase text-gray-900 mb-3 mt-8">How We Use Them</h3>
                    <p className="mb-4">We keep our use of cookies minimal. We use:</p>
                    <ul className="list-disc list-inside space-y-2 ml-4 mb-4">
                      <li><strong>Essential cookies / storage</strong> — to keep you signed in (your session token) so you can access your account and any courses you own. The Site does not work correctly without these.</li>
                      <li><strong>Payment cookies</strong> — set by Stripe during checkout to process your payment securely.</li>
                      <li><strong>Analytics</strong> — privacy-friendly, aggregate usage measurement to understand which content is useful. This does not identify you personally.</li>
                    </ul>
                  </div>

                  <div>
                    <h3 className="font-heading text-xl font-bold uppercase text-gray-900 mb-3 mt-8">Managing Cookies</h3>
                    <p className="mb-4">
                      You can control or delete cookies through your browser settings. Blocking essential cookies will prevent you from signing in or accessing purchased content.
                    </p>
                  </div>

                  <div>
                    <h3 className="font-heading text-xl font-bold uppercase text-gray-900 mb-3 mt-8">Contact</h3>
                    <p className="mb-4">
                      Questions about our use of cookies? Contact us at{' '}
                      <a href="mailto:me@gazar.dev" className="text-[#2d5016] hover:text-[#1a5a3a] hover:underline font-semibold">me@gazar.dev</a>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ContentColumn>
        </section>
      </div>
    </>
  )
}
